/* eslint-disable @typescript-eslint/no-explicit-any */
import { ArrowForwardRounded } from '@mui/icons-material';
import CustomDropdown from '../../reusable/dropdown';
import { settingFormManualMapping } from '../../../redux/slices/form';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { LeadObject } from '../../../params/redux/leads';

interface FacebookValueEntry {
    name: string;
    values: string[];
}

type SnappsValueEntry = Record<string, unknown>;

type CustomValueEntry = Record<string, { label: string; value: string; type: string }>

const MapperOneComponent = ({ destinationRootHeader, selectedIndex }: { destinationRootHeader: Record<string, string>[], selectedIndex: number }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { manual, loaders } = useSelector((state: RootState) => state.form);
    const { leads } = useSelector((state: RootState) => state.lead);

    const handleChange = (header: string, selectedId: string) => {
        const updatedMapping = {
            selectedForm: manual.selectedForm,
            isManual: manual.isManual,
            headers: manual.headers,
            rows: manual.rows,
            selectedLeads: manual.selectedFormLeads,
            mapping: {
                ...manual.mapping,
                [header]: selectedId
            }
        };
        dispatch(settingFormManualMapping(updatedMapping));
    };
    const selectedLead = manual?.selectedFormLeads?.[selectedIndex - 1];
    const leadData: CustomValueEntry | FacebookValueEntry[] | SnappsValueEntry = selectedLead
        ? JSON.parse(selectedLead?.form_data)
        : {};

    return <Box mt={4} px={2}>
        <Grid container spacing={1} sx={{ fontWeight: 'bold', mb: 1, border: '1px solid lightgray', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
            <Grid item xs={4}><Typography variant="subtitle1" color="textSecondary" fontWeight="bold">DESTINATION HEADER</Typography></Grid>
            <Grid item xs={4}><Typography variant="subtitle1" color="textSecondary" fontWeight="bold">IMPORTED HEADER</Typography></Grid>
            <Grid item xs={4}><Typography variant="subtitle1" color="textSecondary" fontWeight="bold">PREVIEW</Typography></Grid>
        </Grid>

        {destinationRootHeader.map((header, idx) => {
            let previewValue: string | undefined = '-';
            if (manual.selectedForm?.type === 'snapps' || manual.selectedForm?.type === 'snapps-manual' || manual.selectedForm?.type === 'elementor' || manual.selectedForm?.type === 'elementor-manual') {
                const fieldId = manual.mapping[header.value] as string;
                previewValue = ((leadData as SnappsValueEntry)[fieldId] as string) ?? '-';
            } else if (manual.selectedForm?.type === 'external') {
                const fieldId = manual.mapping[header.value] as string;
                previewValue = (leadData as FacebookValueEntry[]).find((field: any) => field.name === fieldId)?.values[0] || '-';
                // previewValue = JSON.stringify(leadData);
            } else if (
                leadData &&
                typeof leadData === 'object' &&
                !Array.isArray(leadData) &&
                (leadData as CustomValueEntry)
            ) {
                const fieldId = manual.mapping[header.value] as string;
                previewValue = (leadData as CustomValueEntry)[fieldId]?.value ?? '-';
            }
            return <Grid container spacing={1} key={idx} alignItems="center" mb={1} pb={1} sx={{
                borderLeft: '1px solid lightgray',
                borderRight: '1px solid lightgray',
                borderBottom: '1px solid lightgray',
                borderBottomLeftRadius: idx + 1 === destinationRootHeader.length ? '10px' : '0',
                borderBottomRightRadius: idx + 1 === destinationRootHeader.length ? '10px' : '0'
            }}>
                <Grid item xs={4}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="subtitle1" color="textDisabled">{header.value}</Typography>
                        <ArrowForwardRounded />
                    </Box>
                </Grid>
                <Grid item xs={4}>
                    <CustomDropdown
                        options={manual?.rows?.map((field: any) => ({
                            label: field.label,
                            value: field.id
                        }))}
                        value={(manual.mapping[header.value] as string) || ''}
                        onChange={(e) => handleChange(header.value, e.target.value as string)}
                        disabled={loaders.isCreating}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 200,
                                    overflowY: 'auto'
                                }
                            }
                        }}
                        sx={{
                            mb: 0
                        }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="body2" color="textSecondary">
                        {previewValue}
                        {/* {manual?.rows?.[selectedIndex - 1]?.[manual.mapping[header.value] as string] || '-'} */}
                    </Typography>
                </Grid>
            </Grid>;
        })}
    </Box>;
};


export default MapperOneComponent;